import * as types from "./types";

const mutations = {
    [types.LOADING_DEPARTMENT](state, value) {
        state.loading = value;
    },
    [types.GET_DEPARTMENT_LIST](state, departments) {
        state.departments = departments;
    },
    [types.REMOVE_DEPARTMENT](state, id) {        
        state.departments = state.departments.filter((x) => x.id !== id);        
    },
    [types.ADD_DEPARTMENT](state, department) {        
        state.departments.unshift(department);
    },
    [types.UPDATE_DEPARTMENT](state, department) {        
        const departmentIndex = state.departments.findIndex((x) => x.id === department.id);
        state.departments[departmentIndex] = department;        
    },
    [types.GET_DEPARTMENTBYID](state, departmentId) {
        state.departmentId = departmentId;
    }
};

export default mutations;